import {DashboardCard} from '@hm/fundamental'

import {KilnShutdownForm} from '@refra/modules/common/components/KilnShutdownForm'
import type {NewShutdown} from '@refra/modules/common/types'

interface NewKilnShutdownCardProps {
  shutdown: NewShutdown
}

export const NewKilnShutdownCard: React.FC<NewKilnShutdownCardProps> = ({shutdown}) => {
  return (
    <DashboardCard
      className="flex flex-col gap-3 border-gray-200 border-1px"
      data-cy="new_kiln_shutdown_card"
    >
      <KilnShutdownForm kilnShutdown={shutdown} />
    </DashboardCard>
  )
}
